/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProfileCollaborators_org = {
    readonly id: string;
    readonly collaboratorStatsErrorable: ({
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
    } | {
        readonly __typename: "CollaboratorStats";
        readonly calendarId: string | null;
        readonly topCollaborators: ReadonlyArray<{
            readonly calendarId: string | null;
            readonly sharedMinutes: number | null;
        } | null> | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $refType": "ProfileCollaborators_org";
};
export type ProfileCollaborators_org$data = ProfileCollaborators_org;
export type ProfileCollaborators_org$key = {
    readonly " $data"?: ProfileCollaborators_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProfileCollaborators_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarId",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "calendarId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "rangeMax"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "rangeMin"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "timeZone"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "ProfileCollaborators_org",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "calendarId",
                        "variableName": "calendarId"
                    },
                    {
                        "kind": "Variable",
                        "name": "rangeMax",
                        "variableName": "rangeMax"
                    },
                    {
                        "kind": "Variable",
                        "name": "rangeMin",
                        "variableName": "rangeMin"
                    },
                    {
                        "kind": "Variable",
                        "name": "timeZone",
                        "variableName": "timeZone"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "collaboratorStatsErrorable",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            }
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "CollaboratorScore",
                                "kind": "LinkedField",
                                "name": "topCollaborators",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "sharedMinutes",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "CollaboratorStats",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '4a8b5b7ea58ce744eb6af11f1a212a9b';
export default node;
